import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoutes = () => {
  return sessionStorage.getItem('idToken') != null ? (
    <Outlet />
  ) : (
    <Navigate to='/signin' />
  );
};

export default PrivateRoutes;
